import React, { useState } from "react";
import { useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import InactiveStudentsHeader from "../../../containers/admin/students/inactiveStudentsHeader";
import InactiveStudentsTable from "../../../containers/admin/students/inactiveStudentsTable";
import AddStudent from "../../../containers/admin/students/models/add-student";
import UserQRCode from "../../../containers/admin/students/models/user-qr-code";
import StudentReport from "../../../containers/admin/students/models/student-report";

const InactiveStudents = () => {
  const model = useSelector((state) => state.model.isOpen18);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [inactivePeriod, setInactivePeriod] = useState("oneWeek");
  const [isAdd, setAdd] = useState(false);

  return (
    <Layout>
      <InactiveStudentsHeader
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        inactivePeriod={inactivePeriod}
        setInactivePeriod={setInactivePeriod}
      />
      <InactiveStudentsTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
        inactivePeriod={inactivePeriod}
      />

      <AddStudent
        key={`inactive-student-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
        setAddedStudent={() => {}}
      />
      <UserQRCode data={selectedData} />

      {model && (
        <StudentReport student_id={selectedData?.id} selectedData={selectedData} />
      )}
    </Layout>
  );
};

export default InactiveStudents;
